import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const snapshot = document.getElementById("question-page-entry");
const Home = require("./pages/Home").default;
const page = snapshot ? <Home initialEntry={JSON.parse(snapshot.textContent)} /> : <App />;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {page}
    </QueryClientProvider>
  </React.StrictMode>,
);
